(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eh-products-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.featured-boutique');

  sections.forEach((section) => {
    const forms = section.querySelectorAll('[data-add-to-cart]');
    const message = section.querySelector('[data-cart-message]');

    forms.forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('button');

        if (!button || button.disabled) return;

        const originalText = button.querySelector('span')?.textContent;

        button.disabled = true;

        if (button.querySelector('span')) {
          button.querySelector('span').textContent = 'ADDING...';
        }

        try {
          const formData = new FormData(form);

          const response = await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
              method: 'POST',
              headers: {
                Accept: 'application/json'
              },
              body: formData
            }
          );

          if (!response.ok) {
            throw new Error('Unable to add product to cart.');
          }

          await response.json();

          if (button.querySelector('span')) {
            button.querySelector('span').textContent = 'ADDED';
          }

          if (message) {
            message.classList.add('is-visible');

            setTimeout(() => {
              message.classList.remove('is-visible');
            }, 2500);
          }

          /*
           * Refresh Shopify cart drawer/cart sections
           * when the theme exposes them.
           */
          document.dispatchEvent(
            new CustomEvent('cart:updated')
          );

          setTimeout(() => {
            if (button.querySelector('span')) {
              button.querySelector('span').textContent =
                originalText || 'ADD TO CART';
            }

            button.disabled = false;
          }, 1200);

        } catch (error) {

          console.error(error);

          if (button.querySelector('span')) {
            button.querySelector('span').textContent = 'TRY AGAIN';
          }

          setTimeout(() => {
            if (button.querySelector('span')) {
              button.querySelector('span').textContent =
                originalText || 'ADD TO CART';
            }

            button.disabled = false;
          }, 1500);
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
